export default "__VITE_ASSET__CjKRN6vQ__"